import { Quote } from '@/quote/domain/Quote';
import { QuoteRepository } from '@/quote/domain/QuoteRepository';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { ServicesApiResponse } from '@hfc/ui-core';

export class QuoteApi implements QuoteRepository {

  public async getQuote (applicationType: APPLICATION_TYPES): Promise<ServicesApiResponse<Quote>> {
    const quoteData = applicationType === APPLICATION_TYPES.DENTAL ? localStorage.getItem('dentalQuote') : localStorage.getItem('visionQuote');

    if (quoteData && quoteData !== null) {
      return {
        success: true,
        data: Quote.fromPrimitives(JSON.parse(quoteData))
      };
    }

    return {
      success: true,
    };
  }

}
